import { render } from "./WelcomeUserEmail.vue?vue&type=template&id=11f96469&scoped=true"
import script from "./WelcomeUserEmail.vue?vue&type=script&lang=js"
export * from "./WelcomeUserEmail.vue?vue&type=script&lang=js"

import "./WelcomeUserEmail.vue?vue&type=style&index=0&id=11f96469&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f96469"]])

export default __exports__